module.exports = __webpack_public_path__ + "static/img/header-store.f2eb193.png";